import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-responsive-modal';

import { connect } from 'react-redux';

import { SHOW_MODAL } from 'actions/internal';
import { closeIconPath } from 'containers/modals/ModalRoot';
import { useAsqReminderSendout } from 'hooks/useAsqReminderSendout';

const PlayerSurveyReminderSendout = (props) => {
  const [moreInfoOpen, setMoreInfoOpen] = useState(false);
  const { sendoutData, isLoadingSendouts, refetchSendouts, enqueueReminder } = useAsqReminderSendout(props.surveyId);

  const showModal = () => {
    props.dispatch({
      type: SHOW_MODAL,
      modalType: 'ASQ_REMINDER_CONFIRMATION',
      modalProps: {
        onConfirm: () => enqueueReminder(),
      },
    });
  };

  const handleMoreInfoClick = async (e) => {
    e.preventDefault();
    setMoreInfoOpen(true);
    refetchSendouts();
  };

  const partnerActions = sendoutData?.partner_actions || [];

  return (
    <>
      <div className='u-flex u-flex-column'>
        <button
          className="o-sp-button o-sp-button--base o-sp-button--primary o-sp-button--block u-float--right c-send-parent-message-button"
          onClick={showModal}
        >
          <span className='u-txt--small'>
            <b>
              <i className='fa fa-envelope-o u-margin-right--small'></i>
              ASQ Reminder
            </b>
          </span>
        </button>

        <div className='c-locale-legend'>
          <a href="#" onClick={handleMoreInfoClick}>Click to see all sendouts</a>
        </div>
      </div>
      <Modal
        classNames={{ overlay: 'o-modal__wrap', modal: 'o-modal o-modal__min-height row column u-margin-top--large' }}
        closeIconSvgPath={closeIconPath()}
        closeOnOverlayClick={true}
        open={moreInfoOpen}
        onClose={() => setMoreInfoOpen(false)}
        center
      >
        <div className='u-padding--base'>
          <h3 className='u-margin-bottom--base'>ASQ Reminder Sendouts History</h3>
          <div style={{ overflowY: 'auto', maxHeight: 'calc(90vh - 150px)' }}>
            {isLoadingSendouts ? (
              <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                <i className='o-spinner-dual'></i>
              </div>
            ) : partnerActions.length > 0 ? (
              <table className='o-table o-table--bordered' style={{ width: '100%' }}>
                <thead>
                  <tr>
                    <th>Sent By</th>
                    <th>Sent At</th>
                  </tr>
                </thead>
                <tbody>
                  {partnerActions.map((action, index) => (
                    <tr key={index}>
                      <td>{action.sent_by}</td>
                      <td>{action.sent_at ? new Date(action.sent_at).toLocaleString() : '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                <p style={{ color: '#999', fontSize: '16px' }}>No reminder sendouts yet</p>
              </div>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

PlayerSurveyReminderSendout.propTypes = {
  surveyId: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default connect()(PlayerSurveyReminderSendout);
